<template>
	<div id="app">
		<div id="bg"></div>
		<router-view/>
	</div>
</template>

<script>
export default {
	name: 'App'
}
</script>

<style lang="less">
@import './less/reset.less';
@import './less/default.less';
@import './less/const.less';
body {
	background-color: @color-bg-base;
}
</style>



// WEBPACK FOOTER //
// src/App.vue